import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ServicioEspecialService } from '../../services/servicio-especial.service';
import { ServiciosEspeciales } from '../../model/servicios-especiales';

import { ConsorciosService } from '../../services/consorcios.service';
import { Consorcio } from '../../model/consorcio';
import { SucursalService } from '../../services/sucursal.service';
import { Sucursal } from '../../model/sucursal';

@Component({
  selector: 'app-servicio-especial-list',
  templateUrl: './servicio-especial-list.component.html',
  styleUrls: ['./servicio-especial-list.component.css']
})

export class ServicioEspecialListComponent implements OnInit {

  public modoEdicion: boolean = false;

  public consorcio: Consorcio;
  public consorcios: Consorcio[];

  public sucursal: Sucursal;
  public sucursales: Sucursal[];

  public documento: ServiciosEspeciales;
  public documentos: ServiciosEspeciales[];

  public codigoSucursal: string;
  public filtro:string;
  public query: any;
  public documentoSeleccionado: ServiciosEspeciales = new ServiciosEspeciales();

  constructor(
    private _servicioEspecialService: ServicioEspecialService,
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService
  ) { }

  ngOnInit() {
    this.filtro = "";
    this.documentos = [];
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.codigoSucursal = "";
    this.consorcio = null;
    this.sucursal = null;
    this.documentoSeleccionado = new ServiciosEspeciales();
    this.cargarConsorcios();
  }

  cargarConsorcios() {
    //this._consorcioService.getConsorcios()    
    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
      });

  }

  cargarSucursales() {
    if (this.consorcio === null) {
      return;
    }
    this.query = { "email": sessionStorage.getItem("login"), "codigoConsorcio": this.consorcio.codigoConsorcio }
    this._sucursalService.getSucursalesUsuario(this.query)
      .subscribe(
      data => this.sucursales = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }


  agregarRegistro() {
    if (this.consorcio === null || this.codigoSucursal === "") {
      return;
    }
    this.documentoSeleccionado = new ServiciosEspeciales();
    this.modoEdicion = true;
  }


  regresar() {
    this.modoEdicion = false;
    this.cargarDocumentos();
  }

  cargarDocumentos() {
    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoSucursal: this.codigoSucursal
    };
    this._servicioEspecialService.getServicios(this.query)
      .subscribe(
      data => { this.documentos = data, console.log(data) },
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  editarRegistro(documento: ServiciosEspeciales) {
    this.documentoSeleccionado = documento;
    this.modoEdicion = true;
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/servicio-especial-list/servicio-especial-list.component.ts